import strings from "../../../utils/Strings";
import "../styles/NeedHelpOverallProgressStyles.css";
import { useEffect, useRef, useState } from "react";
import ScoreImg from "../assets/needhelp/scoreImg.png";
import scrollicon from "../assets/needhelp/scrollIcon.png";
import plusIcon from "../assets/needhelp/plus.svg";
import minusIcon from "../assets/needhelp/minus.svg";
import leftPending from "../assets/needhelp/pending1.png";
import rightPending from "../assets/needhelp/pending2.png";
import viewArrow from "../assets/arrow.png";

import CustomTooltipNeedHelp from "../../../components/CustomToolTipComponentsNeedHelp";
import ScrollDownButton from "../assets/needhelp/downArrow.png";
import { RightModalProps } from "./DashboardNeedHelp";
// Reusable question header
export const QuestionHeader = ({
  text,
  onClick,
}: {
  text: string;
  onClick: () => void;
}) => (
  <h1
    style={{
      fontSize: "16px",
      backgroundColor: "#FFFFFF",
      margin: "20px",
      padding: "15px",
      paddingRight: "20px",
      paddingLeft: "20px",
      borderRadius: "40px",
      cursor: "pointer",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontWeight: 400,
      color: "#242730",
      fontFamily: "Mazzard",
    }}
    onClick={onClick}
  >
    {text}
    <span style={{ fontWeight: "bold", fontSize: "20px" }}>
      <img src={plusIcon} />
    </span>
  </h1>
);
// Reusable content wrapper with question + minus
export const ContentWrapper = ({
  question,
  children,
  onClose,
}: {
  question: string;
  children: React.ReactNode;
  onClose: () => void;
}) => (
  <div
    style={{
      margin: "20px",
      // border: "1px solid #ddd",
      borderRadius: "40px",
    }}
  >
    {/* Header with Question + Close button */}
    <div
      style={{
        // backgroundColor: "#c3f1ff",
        backgroundColor: "#FFFFFF",
        padding: "20px",

        borderTopLeftRadius: "40px",
        borderTopRightRadius: "40px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        cursor: "pointer",
      }}
      onClick={onClose}
    >
      <span
        style={{
          fontSize: "16px",
          fontWeight: 400,
          fontFamily: "Mazzard",
          color: "#242730",
        }}
      >
        {question}
      </span>
      <span style={{ fontWeight: "bold", fontSize: "20px" }}>
        <img src={minusIcon} />
      </span>
    </div>

    {/* Content */}
    <div
      style={{
        padding: "20px",
        paddingTop: "0px",
        // backgroundColor: "#c3f1ff",
        backgroundColor: "#FFFFFF",
        borderBottomLeftRadius: "40px",
        borderBottomRightRadius: "40px",
      }}
    >
      {children}
    </div>
  </div>
);
const DashboardNeedHelpOverallProgress: React.FC<RightModalProps> = ({
  isOpen,
  toggleModal,
}) => {
  const [activeQuestion, setActiveQuestion] = useState<
    null | "progress" | "pending"
  >(null);
  const [active2Question, setActive2Question] = useState<
    null | "progress" | "pending"
  >(null);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const pendingCardRef = useRef<HTMLDivElement | null>(null);
  const progressCardRef = useRef<HTMLDivElement | null>(null);

  // Scroll to top function
  const [isAtTop, setIsAtTop] = useState(false);
  const [isbuttonShow, setIsbuttonShow] = useState(true);

  // Scroll Up
  const scrollToTop = () => {
    if (containerRef.current) {
      containerRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  // Scroll Down
  const scrollToBottom = () => {
    if (containerRef.current) {
      containerRef.current.scrollTo({
        top: containerRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  // Track container scroll
  useEffect(() => {
    const handleScroll = () => {
      if (containerRef.current) {
        setIsAtTop(containerRef.current.scrollTop < 50);
      }
    };

    const current = containerRef.current;
    current?.addEventListener("scroll", handleScroll);

    return () => current?.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        overflow: "auto",
        height: "700px",
        scrollBehavior: "smooth",
        marginBottom: "20px",
      }}
    >
      {/* First Question */}
      {activeQuestion === "progress" ? (
        <ContentWrapper
          question={strings.needHelp.progressQues1}
          onClose={() => setActiveQuestion(null)}
        >
          <div className="needhelpv2-overallprogressContainer">
            <div className="neddhelpv2-overallprogress-left-column">
              <div
                className="needhelpv2-needhelpOPcardtext"
                ref={progressCardRef}
              >
                {/* <p>{strings.needHelp.overAllProgressCardTxt}</p> */}
                <p>{strings.needHelp.overAllProgressCardTxtV2}</p>
              </div>
              <img
                src={ScoreImg}
                style={{
                  height: "50%",
                  width: "100%",
                  // objectFit: "contain",
                }}
              />
            </div>
            {/* <div className="neddhelpv2-overallprogress-right-column">
              <img
                src={ScoreImg}
                style={{
                  height: "300px",
                  width: "500px",
                  objectFit: "contain",
                }}
              />
            </div> */}
          </div>
        </ContentWrapper>
      ) : (
        <QuestionHeader
          text={strings.needHelp.progressQues1}
          onClick={() => {
            setIsbuttonShow(false);
            setActiveQuestion("progress");
          }}
        />
      )}

      {/* Second Question */}
      {/* {active2Question === "pending" ? (
        <ContentWrapper
          question={strings.needHelp.progressQues2}
          onClose={() => setActive2Question(null)}
        >
          <div className="needhelpv2-overallTopprogressContainer">
            <div className="needhelpv2-needhelpOPcardtext" ref={pendingCardRef}>
             
              <p>
                {
                  strings.needHelp.overAllProgressPendingCardTxt.split(
                    `"View Pending Items"`,
                  )[0]
                }
                <CustomTooltipNeedHelp
                  title={
                    <div
                      // className="dash-overAllViewTab"
                      style={{
                        backgroundColor: "#395B9C",
                        height: "40px",
                        width: "100%",
                        borderRadius: "24px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "#FFFFFF",
                        fontSize: "14px",
                        fontWeight: "500",
                        padding: "10px",
                        // cursor: "pointer",
                        fontFamily: "MazzardMedium",
                      }}
                      onClick={() => {}}
                    >
                      View Pending Items{" "}
                      <img
                        src={viewArrow}
                        alt="view"
                        style={{
                          height: "20px",
                          width: "20px",
                          marginLeft: "5px",
                        }}
                      />
                    </div>
                  }
                >
                  <span
                    style={{
                      backgroundColor: "#9FDCEE",
                      cursor: "pointer",

                      padding: "2px 6px",
                      borderRadius: "4px",
                    }}
                  >
                    "View Pending Items"
                  </span>
                </CustomTooltipNeedHelp>
                {
                  strings.needHelp.overAllProgressPendingCardTxt.split(
                    `"View Pending Items"`,
                  )[1]
                }
              </p>
            </div>
            <div className="needhelpv2-overallprogressContainer">
              <div className="needhelpv2pending-overallprogress-left-column">
                <img
                  src={leftPending}
                  style={{ height: "300px", width: "500px" }}
                />
              </div>
              <div className="needhelpv2pending-overallprogress-right-column">
                <img
                  src={rightPending}
                  style={{ height: "300px", width: "500px" }}
                />
              </div>
            </div>
          </div>
        </ContentWrapper>
      ) : (
        <QuestionHeader
          text={strings.needHelp.progressQues2}
          onClick={() => setActive2Question("pending")}
        />
      )} */}
      {isOpen && (
        <div
          onClick={isAtTop ? scrollToBottom : scrollToTop}
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            backgroundColor: "#B8BDc7",
            color: "#333333",
            fontWeight: 500,
            fontSize: "13px",
            boxShadow: "0px 1px 5px 0px #00000040",
            width: isAtTop ? "110px" : "100px",
            borderRadius: "18px",
            padding: "8px 8px",
            textAlign: "center",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "6px",
            paddingLeft: 0,
            paddingRight: 0,
            zIndex: 9999, // ✅ ensures it's above other content
          }}
        >
          {isAtTop ? (
            <>
              Scroll Down{" "}
              <img
                src={ScrollDownButton}
                alt="scroll-down"
                style={{ height: "20px", width: "20px" }}
              />
            </>
          ) : (
            <>
              Scroll Up{" "}
              <img
                src={scrollicon}
                alt="scroll-up"
                style={{ height: "20px", width: "20px" }}
              />
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default DashboardNeedHelpOverallProgress;
